import React from 'react';
import { SVGProps } from './SVGProps';
import classnames from 'classnames';

/**
 * Right chevron SVG
 *
 * @returns
 */
function RightChevronSVG({ className, ...rest }: SVGProps) {
	return (
		<svg
			viewBox="0 0 24 24"
			className={classnames('roc-icon roc-icon-right-chevron ', className)}
			focusable="false"
			aria-hidden="true"
			{...rest}
		>
			<path d="M9.707 18.707l6-6c0.391-0.391 0.391-1.024 0-1.414l-6-6c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414l5.293 5.293-5.293 5.293c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0z"></path>
		</svg>
	);
}

export default RightChevronSVG;
